<!--
  上传图片
-->
<template>
  <div class="upload_wrap">
    <div class="upload_box" v-show="occupiedCount < max">
      <!--图片、视频上传-->
      <el-upload
        list-type="picture-card"
        drag
        :disabled="isdisabled"
        :action="uploadUrl"
        :multiple="multiple"
        :headers="file_headers"
        :show-file-list="false"
        :file-list="uploadFileList"
        :limit="max"
        :before-upload="beforeUpload"
        :on-change="handleUploadChange"
        :on-exceed="handleUploadExceed"
        :on-success="hanldleSuccessUpload"
        :on-error="handleUploadError"
        :auto-upload="true"
        :accept="accept"
        ref="upload"
      >
        <i class="el-icon-plus"></i>
        <!-- <div class="upload_btn">+本地上传</div> -->
      </el-upload>
    </div>

    <!--图片预览-->
    <div class="upload_file">
      <div v-for="(item, index) in displayItems" :key="item.uid || item.url || index" style="display: inline-block" class="file_con">
        <!-- <img @click="selectImg(item, index)" width="148" height="148" style="margin-right：10px" :src="item.url" v-if="!/\.mp4$/.test(item)" alt="" /> -->
        <el-image v-if="item.url && !/\.mp4$/i.test(item.url)" style="width: 148px; height: 148px" :src="item.url" :preview-src-list="imgListView"> </el-image>
        <video v-else-if="item.url" width="180" height="180" style="margin-right：10px" :src="item.url" controls="controls"></video>
        <div v-else class="upload_status" :class="{ upload_failed: item.status === 'failed' }">
          <i :class="item.status === 'failed' ? 'el-icon-warning-outline' : 'el-icon-loading'"></i>
          <span>{{ item.status === 'failed' ? '上传失败' : '上传中' }}</span>
          <small>{{ item.name }}</small>
        </div>

        <div class="file_delete" @click="dele(item, index)" v-if="delShow">
          <i class="el-icon-delete"></i>
          删除
        </div>

        <div class="select_box" :class="{ chooseImg: activeIndex == index }" v-if="showSelect">
          <i class="el-icon-check"></i>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
import BASE_API from '@/config';
import { getToken } from '@/utils/localStorage.js';
import { appendImageInSelectionOrder, ensureImageUid, imageUploadMixin, normalizeImageList } from '@/utils/imageUpload.js';
export default {
  name: 'ImageUpload',
  mixins: [imageUploadMixin],
  /*
  imgList 图片数组
  max 最多传多少张
  accept 接受文件类型 .jpj,.png,.mp4 ....

  delShow 是否显示删除按钮
  showSelect 是否显示选中图片
  */
  props: {
    imgList: {
      type: Array,
      default: () => [],
    },
    max: {
      type: Number,
      default: 10,
    },
    fileName: String,
    accept: {
      type: String,
      default: '.jpg,.jpeg,.png,.bmp,.gif', // 允许上传的文件后缀
    }, // 接受文件类型
    delShow: {
      type: Boolean,
      default: true,
    },
    showSelect: {
      type: Boolean,
      default: false,
    },
    isdisabled: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialogImageUrl: '',
      dialogVisible: false,
      activeIndex: '', //选中的图片值
      uploadingCount: 0,
      uploadQueue: [],
      uploadFileList: [],
      uploadUrl: BASE_API + 'admin/work_upload_admin', // 上传链接
      file_headers: {
        // Accept: 'application/json',
        // route: '/dashboard',
        Authorization: 'Bearer' + ' ' + getToken(),
      },
    };
  },
  computed: {
    imgListView() {
      return normalizeImageList(this.imgList, 'preview').map((item) => item.url);
    },
    displayItems() {
      return normalizeImageList(this.imgList, 'history').concat(this.uploadQueue);
    },
    occupiedCount() {
      return this.imgList.length + this.uploadQueue.filter((item) => item.status === 'queued' || item.status === 'uploading').length;
    },
  },
  watch: {
    imgList(newValue, oldValue) {
      if (newValue !== oldValue) this.resetUploadSession();
      this.syncUploadFileList();
    },
  },
  methods: {
    // 上传开始前锁定一个名额，避免并发上传突破当前入口的张数上限
    beforeUpload(file) {
      if (this.imgList.length + this.uploadingCount >= this.max) {
        this.uploadQueue = this.uploadQueue.filter((item) => item.uid !== file.uid);
        this.syncUploadFileList();
        this.emitUploadState();
        this.$message.warning(`最多上传${this.max}张`);
        return false;
      }
      this.uploadingCount += 1;
      const queueItem = this.uploadQueue.find((item) => item.uid === file.uid);
      if (queueItem) queueItem.status = 'uploading';
      this.$emit('uploading-change', this.uploadingCount);
      this.emitUploadState();
      return true;
    },
    handleUploadChange(file, fileList) {
      if (file.status === 'ready' && !this.uploadQueue.some((item) => item.uid === file.uid)) {
        this.uploadQueue.push({
          uid: file.uid,
          name: file.name,
          raw: file.raw,
          status: 'queued',
        });
      }
      this.trackImageUpload('images', file, fileList);
      this.emitUploadState();
    },
    handleUploadExceed(files, fileList) {
      this.handleImageUploadExceed(this.max, files, fileList);
    },
    // 删除图片
    dele(item, index) {
      const queueIndex = this.uploadQueue.findIndex((queueItem) => queueItem.uid === item.uid);
      if (queueIndex >= 0) {
        const queueItem = this.uploadQueue[queueIndex];
        const uploadFile = this.$refs.upload && this.$refs.upload.uploadFiles.find((file) => file.uid === item.uid);
        if (uploadFile) {
          uploadFile.__imageUploadRemoved = true;
          if (uploadFile.raw) uploadFile.raw.__imageUploadRemoved = true;
          this.$refs.upload.abort(uploadFile);
          this.$refs.upload.handleRemove(uploadFile);
        }
        if (queueItem.status === 'uploading') this.finishUpload();
        this.uploadQueue.splice(queueIndex, 1);
      } else {
        const imageIndex = this.imgList.findIndex((image) => image.uid === item.uid || image.url === item.url);
        if (imageIndex >= 0) this.imgList.splice(imageIndex, 1);
      }
      this.syncUploadFileList();
      this.emitUploadState();
    },
    hanldleSuccessUpload(response, file, fileList) {
      if (!this.isCurrentImageUpload('images', file)) return;
      this.finishUpload();
      const queueItem = this.uploadQueue.find((item) => item.uid === file.uid);
      if (response.code === 200) {
        const image = {
          name: response.data.name || file.name,
          url: response.data.path,
        };
        if (queueItem) {
          queueItem.status = 'success';
          queueItem.image = image;
        }
      } else {
        if (queueItem) queueItem.status = 'failed';
        this.$message.error(response.message);
      }
      this.flushCompletedUploads();
      this.trackImageUpload('images', file, fileList);
      this.emitUploadState();
    },
    handleUploadError(error, file, fileList) {
      if (!this.isCurrentImageUpload('images', file)) return;
      this.finishUpload();
      const queueItem = this.uploadQueue.find((item) => item.uid === file.uid);
      if (queueItem) queueItem.status = 'failed';
      this.trackImageUpload('images', file, fileList);
      this.$message.error('图片上传失败');
      this.flushCompletedUploads();
      this.emitUploadState();
    },
    finishUpload() {
      this.uploadingCount = Math.max(0, this.uploadingCount - 1);
      this.$emit('uploading-change', this.uploadingCount);
    },
    flushCompletedUploads() {
      if (this.uploadingCount > 0) return;
      const completed = this.uploadQueue.filter((item) => item.status === 'success').sort((left, right) => Number(left.uid) - Number(right.uid));
      completed.forEach((item) => {
        const image = ensureImageUid(item.image, 'upload');
        const next = appendImageInSelectionOrder(this.imgList, { uid: item.uid }, image);
        this.imgList.splice(0, this.imgList.length, ...next);
        this.$emit('select', image);
      });
      this.uploadQueue = this.uploadQueue.filter((item) => item.status !== 'success');
      this.syncUploadFileList();
    },
    syncUploadFileList() {
      const history = normalizeImageList(this.imgList, 'history');
      const active = this.uploadQueue
        .filter((item) => item.status === 'queued' || item.status === 'uploading')
        .map((item) => ({ uid: item.uid, name: item.name, status: item.status === 'queued' ? 'ready' : 'uploading', raw: item.raw }));
      this.uploadFileList = history.concat(active);
    },
    emitUploadState() {
      const failedCount = this.uploadQueue.filter((item) => item.status === 'failed').length;
      const queuedCount = this.uploadQueue.filter((item) => item.status === 'queued').length;
      this.$emit('upload-state-change', {
        queuedCount,
        uploadingCount: this.uploadingCount,
        failedCount,
        canSubmit: queuedCount === 0 && this.uploadingCount === 0 && failedCount === 0,
      });
    },
    resetUploadSession() {
      this.resetImageUploadScope('images');
      if (this.$refs.upload) this.$refs.upload.abort();
      this.uploadQueue = [];
      this.uploadingCount = 0;
      this.$emit('uploading-change', 0);
      this.emitUploadState();
    },

    // 选中图片
    selectImg(item, index) {
      // console.log(item)
      this.activeIndex = index;
    },
  },

  created() {
    this.syncUploadFileList();
  },
  beforeDestroy() {
    this.resetUploadSession();
  },
};
</script>
<style lang="less" scoped>
.upload_wrap {
  display: inline-block;
  display: flex;

  .upload_box {
    width: 148px;
    height: 148px;
    background: #f6f7fb;
    border-radius: 2px;
    border: 1px solid #cccccc;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-right: 10px;
    .upload_btn {
      line-height: 32px;
      border: 1px solid #ccc;
      padding: 0 16px;
    }
    /deep/.el-upload--text {
      // width: 148px;
      // height: 148px;
      width: 100px;
      height: 34px;
      border: none;
      border-radius: 0;
      color: #999999;
      background: #f6f7fb;
      margin-left: 0 !important;
      // overflow: unset;
    }
  }
  .upload_file {
    display: flex;
    flex-wrap: wrap;
    .file_con {
      min-width: 148px;
      min-height: 148px;
      margin-right: 10px;
      position: relative;
      .file_delete {
        position: absolute;
        bottom: 0;
        width: 148px;
        height: 36px;
        background: #000000;
        border-radius: 0px 0px 4px 4px;
        opacity: 0.7;
        color: #fff;
        text-align: center;
        line-height: 36px;
        display: none;
        cursor: pointer;
      }
      &:hover .file_delete {
        display: block;
      }
    }

    .upload_status {
      width: 148px;
      height: 148px;
      padding: 20px 10px;
      border: 1px dashed #c0c4cc;
      box-sizing: border-box;
      color: #909399;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      text-align: center;

      i {
        margin-bottom: 8px;
        font-size: 24px;
      }

      small {
        width: 100%;
        margin-top: 6px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }

    .upload_failed {
      color: #f56c6c;
      border-color: #f56c6c;
    }

    .select_box {
      position: absolute;
      top: 10px;
      right: 10px;
      color: #fff;
      font-size: 26px;
      font-weight: 700;
      width: 29px;
      height: 29px;
      line-height: 29px;
      text-align: center;
      background: #000000;
      opacity: 0.9;
    }

    .chooseImg {
      background: #6288fd;
    }
  }
}
</style>
